module.exports = {"360734100":"长宁镇","360734101":"晨光镇","360734102":"留车镇","360734103":"南桥镇","360734104":"吉潭镇","360734105":"澄江镇","360734106":"桂竹帽镇","360734200":"文峰乡","360734201":"三标乡","360734202":"菖蒲乡","360734203":"龙廷乡","360734204":"丹溪乡","360734205":"项山乡","360734206":"水源乡","360734207":"罗珊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360734.json
// module id = 1201
// module chunks = 0